import { render, staticRenderFns } from "./roomPriceList.vue?vue&type=template&id=5ae2d486&scoped=true"
import script from "./roomPriceList.vue?vue&type=script&lang=js"
export * from "./roomPriceList.vue?vue&type=script&lang=js"
import style0 from "./roomPriceList.vue?vue&type=style&index=0&id=5ae2d486&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2d486",
  null
  
)

export default component.exports